import { Navigate, Outlet } from 'react-router-dom'
import { authClient } from '../auth'
import { RouteLoader } from './RouteLoader'

export function RequireAuth() {
  const { data, isPending } = authClient.useSession()
  if (isPending) return <RouteLoader />
  if (!data?.session) return <Navigate to="/signin" replace />
  return <Outlet />
}
